import { FC } from "react";
import EditAccountTypeDialog, {
  EditAccountTypeDialogProps,
} from "./EditAccountTypeDialog";
import { AccountTypeAPI } from "../../../api";

const CreateAccountTypeDialog: FC<EditAccountTypeDialogProps> = (props) => {
  return (
    <EditAccountTypeDialog
      title="Create Account Type"
      confirmText="Create"
      save={AccountTypeAPI.create}
      {...props}
    ></EditAccountTypeDialog>
  );
};

export default CreateAccountTypeDialog;
